import { lifecycle, compose } from "recompose";
import { withShop } from "web/core/shop/ShopContext";
import HeaderQuery from "theme/layouts/Header/HeaderQuery.gql";
import { graphql } from "react-apollo";

const getCustomerDataLayer = (props) => {
  const customer = props.customer;

  let Customer = {
    user: {
      logged: customer && customer.id ? "1" : "0",
      userId: customer ? customer.encodedEmail : "",
    },
  };

  return Customer;
};

const getPageDataLayer = (props) => {
  let pageType = "other";
  let ecomCateg = null;

  if (typeof props.cms !== "undefined" && props.cms.identifier === "home") {
    pageType = "home";

    return {
      google_tag_params: {
        ecomm_pagetype: pageType,
      },
    };
  }

  if (props.category) {
    ecomCateg = props.category.name;
    pageType = "category";
  } else if (props.product) {
    ecomCateg = props.product.name;
    pageType = "product";
  }

  let googleTagParams = {
    ecomm_pagetype: pageType,
  };

  if (ecomCateg) {
    googleTagParams["ecomm_category"] = ecomCateg;
  }

  const Page = {
    google_tag_params: googleTagParams,
  };
  return Page;
};

const getQuoteDataLayer = (props) => {
  const quote = props.quote;

  if (quote && quote.items_qty) {
    const QuoteLayer = {
      ecomm_totalvalue:
        quote && quote.totals ? quote.totals.totalExclTax.value.amount : 0,
      ecomm_prodid:
        quote && quote.items.length ? quote.items.map((item) => item.sku) : "",
    };
    window.dataLayer = window.dataLayer || [];
    return { google_tag_params: QuoteLayer };
  }
};

const withGlobalDataLayer = compose(
  graphql(HeaderQuery, {
    props: ({ data }) => {
      return {
        quote: data.cart,
        customer: data.me,
      };
    },
  }),
  withShop(),
  lifecycle({
    componentDidMount: function () {
      if (
        this.props.category &&
        window.location.search.indexOf("sort") === -1
      ) {
        return;
      }

      window.dataLayer = window.dataLayer || [];
      let baseDataLayer = {
        event: "er_page_view",
      };
      window.stopImmediateEcommerceDataLayer = false;

      if (
        typeof this.props.cms !== "undefined" &&
        localStorage.getItem("prevLocationPath") &&
        window.location.pathname !== localStorage.getItem("prevLocationPath")
      ) {
        baseDataLayer = {
          event: "er_page_view_asc",
        };
      }

      if (
        this.props.category &&
        window.location.pathname !== localStorage.getItem("prevLocationPath")
      ) {
        baseDataLayer = {
          event: "er_page_view_asc",
        };
      }

      const finalDataLayer = {
        ...baseDataLayer,
        ...getQuoteDataLayer(this.props),
        ...getCustomerDataLayer(this.props),
        ...getPageDataLayer(this.props),
      };

      window.dataLayer.push(finalDataLayer);
      localStorage.setItem("prevLocationPath", window.location.pathname);
    },
    componentDidUpdate() {
      if (
        window.location.search.indexOf("sort") === -1 &&
        typeof this.props.category !== "undefined"
      ) {
        return;
      }

      window.stopImmediateEcommerceDataLayer = false;

      if (
        !localStorage.getItem("prevLocationPath") ||
        localStorage
          .getItem("prevLocationPath")
          .indexOf(window.location.pathname) !== -1
      ) {
        localStorage.setItem("prevLocationPath", window.location.pathname);
        return;
      }

      localStorage.setItem("prevLocationPath", window.location.pathname);

      let Layer = {
        event: "er_page_view_asc",
        page: {
          path: window.location.pathname,
          title: document.title,
          location: window.location.href,
          referrer: document.referrer,
        },
        ecommerce: undefined,
      };

      window.dataLayer = window.dataLayer || [];

      const finalDataLayer = {
        ...Layer,
        ...getQuoteDataLayer(this.props),
        ...getCustomerDataLayer(this.props),
        ...getPageDataLayer(this.props),
      };

      window.dataLayer.push(finalDataLayer);
    },
  })
);

export default withGlobalDataLayer;
